const widgetShadowHost = document.createElement('div')
widgetShadowHost.setAttribute('id', 'mayaChatWidget')

document.body.appendChild(widgetShadowHost)

widgetShadowHost.attachShadow({ mode: 'open' })
